import React, { useContext } from "react";
import NextLink from "next/link";

import ListGroup from "react-bootstrap/ListGroup";
import { colors } from "utils/styles";
import { Icon } from "@components/Icons";
import { useRouter } from "next/router";
import { NavContext } from "contexts/";
import DynamicLink from "@components/Reusables/DynamicLink";
export default function NavColumn(props) {
	return (
		<div style={{ minWidth: "200px" }}>
			{/* //title with icon */}
			<Title icon={props.data.icon} text={props.data.title} />
			{/* List of items */}
			<ListGroup className="ps-4">
				{props.data.items.map((item, i) => (
					<Item key={i} item={item} />
				))}
			</ListGroup>
		</div>
	);
}

/**
 *
 * @param {icon, text} props {icon with text, optional text, otherwise invisible placeholder}
 * @returns
 */
function Title(props) {
	const isPlaceholder = props.text === "placeholder";
	return (
		<h2 className={`title mb-0 ${isPlaceholder ? "d-none d-lg-block" : ""}`} style={{}}>
			<>
				{props.icon && <Icon icon={props.icon} style={{ paddingRight: "0.3rem" }} />}
				{props.text}
			</>
			<style jsx="true">{`
				.title {
					line-height: 36px;
					font-size: 14px;
					font-weight: 600;
					font-family: "Open Sans";
					color: ${colors.lightBlue};
					display: flex;
					visibility: ${isPlaceholder ? "hidden" : "visible"};
					align-items: center;
					white-space: nowrap;
				}
			`}</style>
		</h2>
	);
}

function Item(props) {
	const router = useRouter();
	const { closeNav } = useContext(NavContext);

	const asPath = router.asPath.split("?")[0];
	let isCurrentRoute = asPath === props.item.link;
	return (
		<DynamicLink href={props.item.link}>
			<ListGroup.Item
				style={{
					border: "none",
					padding: "0.5em 0em",
					display: "inline-block",
				}}
			>
				<>
					<p onClick={closeNav} className="mainText mb-0 relative">
						{props.item.text}
						{props.item.icon && (
							<Icon
								className={props.item.iconClass}
								icon={props.item.icon}
								style={{ ...props.item.iconStyle }}
							/>
						)}
					</p>

					{props.item.subText && <p className="subText">{props.item.subText}</p>}
				</>
			</ListGroup.Item>

			<style jsx="true">{`
				.mainText {
					color: ${isCurrentRoute ? colors.green : colors.darkBlue};
					font-weight: 600;
					font-size: 14px;
					line-height: 21px;
					font-family: "Open Sans";
					display: inline-block;
				}

				@media screen and (min-width: 992px) {
					.mainText {
						max-width: 170px;
					}
				}
				.subText {
					line-height: 21px;
					font-size: 14px;
					font-family: "Open Sans";
					font-weight: 400;
					color: ${colors.greyBlue};
				}

				@media screen and (min-width: 992px) {
					.subText {
						max-width: 170px;
					}
				}
			`}</style>
		</DynamicLink>
	);
}
